import { render, staticRenderFns } from "./weChatChannel.vue?vue&type=template&id=51023810&scoped=true"
import script from "./weChatChannel.vue?vue&type=script&lang=js"
export * from "./weChatChannel.vue?vue&type=script&lang=js"
import style0 from "./weChatChannel.vue?vue&type=style&index=0&id=51023810&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51023810",
  null
  
)

export default component.exports